import React from 'react';
import * as S from './HeaderLeftAction.styles';
import { useNavigationStore } from '@/store/useNavigationStore';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { DesktopNav } from '@/components/DesktopNav';
import { BurgerNav } from '@/components/BurgerNav';
import { useBreakpoint } from '@/hooks/useBreakpoint';

interface HeaderLeftActionProps {
  hasBurger?: boolean;
}

export const HeaderLeftAction = ({ hasBurger }: HeaderLeftActionProps) => {
  const [canGoBack, goBack] = useNavigationStore(state => [
    state.canGoBack,
    state.goBack,
  ]);
  const isBackButton = canGoBack && !hasBurger;
  const { isDesktop } = useBreakpoint();
  const [isNavOpen, toggleNav] = useNavMenuStore(state => [
    state.isNavOpen,
    state.toggleNav,
  ]);
  const [isDesktopCatalogueOpen, toggleDesktopCatalogue] =
    useDesktopCatalogueStore(state => [
      state.isDesktopCatalogueOpen,
      state.toggleDesktopCatalogue,
    ]);

  function onClick() {
    if (isBackButton && !isDesktop) {
      goBack();
    } else if (isDesktop) {
      toggleNav();

      if (isDesktopCatalogueOpen) {
        toggleDesktopCatalogue();
      }
    } else {
      toggleNav();
    }
  }

  function getIcon() {
    if (isDesktop && isNavOpen) {
      return (
        <S.DesktopHeaderCloseMenuIcon
          data-testid={CommonTestIds.navMenu.close}
          onClick={onClick}
        />
      );
    }

    if (!isDesktop && isBackButton) {
      return (
        <S.HeaderAngleBackIcon
          data-testid={CommonTestIds.header.backButton}
          onClick={onClick}
        />
      );
    }

    return (
      <S.HeaderMenuIcon
        isDesktop={isDesktop}
        data-testid={CommonTestIds.navMenu.button}
        aria-label="Menu"
        onClick={onClick}
      />
    );
  }

  function getNavMenu() {
    if (isDesktop) {
      return <DesktopNav />;
    }

    return isBackButton ? null : <BurgerNav />;
  }

  return (
    <>
      <S.HeaderLeftActionBtn>{getIcon()}</S.HeaderLeftActionBtn>
      {getNavMenu()}
    </>
  );
};
